import { c as _c } from "react/compiler-runtime";
import { Grid, Image, TextPassage } from '@petsmart-ui/sparky';
import type { ReactElement } from 'react';
import type { BenefitsItem, LoyaltyBenefitsItem, LoyaltyImage } from '@libs/contentful';
import './BenefitItems.scss';
const componentClassName = 'benefit-items';
export function BenefitItems(t0) {
  const $ = _c(2);
  const {
    items
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items?.length ? <Grid.Item className={`${componentClassName}`} data-testid="benefit-items">{items?.map(_temp)}</Grid.Item> : null;
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(item) {
  const fields = item?.fields;
  if (!fields) {
    return null;
  }
  const isLoyaltyBenefit = "benefitImage" in fields;
  const imageField = (isLoyaltyBenefit ? fields?.benefitImage as LoyaltyImage : fields?.benefitIcon) as LoyaltyImage;
  const textField = (isLoyaltyBenefit ? fields?.benefitDescription : fields?.benefitTitle) as string;
  return <div key={fields?.identifier} className={`${componentClassName}__item`}>{!!imageField && <Image className={`${componentClassName}__item--icon`} src={imageField?.fields?.remoteDesktopImageUrl} alt={imageField?.fields?.webAltText} data-testid="benefit-item-image" />}{!!textField && <TextPassage>{textField}</TextPassage>}</div>;
}